<template>
  <div
    class="flex flex-wrap items-center justify-between mb-3 lg:mb-0 md:flex-no-wrap"
  >
    <h1>{{ $t("main.matching") }}</h1>
    <pdf-page />
  </div>
</template>

<script>
export default {
  components: { PdfPage: () => import('@/components/print/PdfPage.vue') }
};
</script>

<style></style>
